export default __webpack_public_path__ + "static/media/sierpien.e0ec65ca.mp3";